import { classNames, useEffect } from 'libs/react';
import { DealItemPickerPackageItem } from './DealItemPickerPackageItem';
import { React } from 'libs/react';
import { useDealItemPicker } from './DealItemPicker';
import { DealItemPickerPackageTable } from './DealItemPickerPackageTable';
import { Text } from 'components/Text';
import './DealItemPickerPackageList.scss';
/**
 * @component DealItemPickerPackageList
 * @since 1.0.0
 */
export function DealItemPickerPackageList(props) {
    var _a;
    const { style, cardDisplay } = Object.assign({ style: 'normal' }, props);
    const { item, packages, appendPackage } = useDealItemPicker();
    const className = classNames('deal-item-picker-package-list', 'deal-item-picker-package-list--' + style, props.className);
    if (!(item === null || item === void 0 ? void 0 : item.packages) ||
        !(item === null || item === void 0 ? void 0 : item.packages.filter((item) => item.package.active && !item.package.deletedAt).length)) {
        return React.createElement(Text, { value: t('No Packages') });
    }
    useEffect(() => {
        item === null || item === void 0 ? void 0 : item.packages.forEach((pack) => {
            var _a;
            if (pack.included || pack.locked || pack.proposed) {
                if (packages.find((entry) => entry.package.id == pack.package.id) == null) {
                    appendPackage(pack.package, (_a = pack.proposed) !== null && _a !== void 0 ? _a : false, 1);
                }
            }
        });
    }, []);
    return (React.createElement("div", null, cardDisplay ? (React.createElement("div", { className: className }, (_a = item === null || item === void 0 ? void 0 : item.packages.filter((item) => item.package.active && !item.package.deletedAt)) === null || _a === void 0 ? void 0 : _a.map((data) => (React.createElement(DealItemPickerPackageItem, { key: data.id, data: data }))))) : (React.createElement(DealItemPickerPackageTable, { values: item === null || item === void 0 ? void 0 : item.packages.filter((item) => item.package.active && !item.package.deletedAt) }))));
}
